import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  coordinate: {
    fontSize: '.9rem',
  }
}));
